import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer className="bg-surface-secondary border-t border-white/[0.06]">
      <div className="max-w-[1200px] mx-auto px-6 pt-16 pb-8">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10 mb-12">
          <div>
            <span className="font-display text-2xl font-bold italic text-gold block mb-4">
              JL-Software
            </span>
            <p className="text-text-muted text-sm leading-relaxed max-w-[280px]">
              Ein unabhängiges Indie-Game-Studio aus Deutschland. Wir entwickeln
              digitale Spieleerlebnisse mit Fokus auf Kreativität und Qualität.
            </p>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.1em] text-text-primary mb-5">
              Navigation
            </h4>
            <ul className="flex flex-col gap-3">
              <li>
                <Link
                  to="/"
                  className="text-text-muted text-sm hover:text-gold transition-colors"
                >
                  Startseite
                </Link>
              </li>
              <li>
                <Link
                  to="/shop"
                  className="text-text-muted text-sm hover:text-gold transition-colors"
                >
                  Shop
                </Link>
              </li>
              <li>
                <Link
                  to="/ueber-uns"
                  className="text-text-muted text-sm hover:text-gold transition-colors"
                >
                  Über uns
                </Link>
              </li>
              <li>
                <Link
                  to="/kontakt"
                  className="text-text-muted text-sm hover:text-gold transition-colors"
                >
                  Kontakt
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.1em] text-text-primary mb-5">
              Rechtliches
            </h4>
            <ul className="flex flex-col gap-3">
              <li>
                <Link
                  to="/impressum"
                  className="text-text-muted text-sm hover:text-gold transition-colors"
                >
                  Impressum
                </Link>
              </li>
              <li>
                <Link
                  to="/datenschutz"
                  className="text-text-muted text-sm hover:text-gold transition-colors"
                >
                  Datenschutz
                </Link>
              </li>
              <li>
                <Link
                  to="/agb"
                  className="text-text-muted text-sm hover:text-gold transition-colors"
                >
                  AGB
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-bold uppercase tracking-[0.1em] text-text-primary mb-5">
              Kontakt
            </h4>
            <ul className="flex flex-col gap-3">
              <li>
                <a
                  href="mailto:support@jl-software.dns.army"
                  className="text-text-muted text-sm hover:text-gold transition-colors"
                >
                  E-Mail
                </a>
              </li>
              <li>
                <span className="text-text-muted text-sm">
                  Discord (bald)
                </span>
              </li>
              <li>
                <span className="text-text-muted text-sm">
                  Twitter / X (bald)
                </span>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/[0.06] pt-6 flex flex-col sm:flex-row justify-between items-center gap-4">
          <span className="text-text-muted text-xs">
            &copy; 2026 JL-Software. Alle Rechte vorbehalten.
          </span>
          <span className="text-text-muted text-xs">
            Mit ❤️ entwickelt in Deutschland
          </span>
        </div>
      </div>
    </footer>
  );
}
